/**
 * The `wpp::form.wysiwyg` field.
 *
 * Kept out of `index.js` so that TipTap is only bundled by applications that
 * actually render a rich text field:
 *
 *     npm i @tiptap/core @tiptap/pm @tiptap/starter-kit
 *
 *     import { registerWppWysiwyg } from '.../resources/js/wysiwyg';
 *     registerWppWysiwyg(Alpine);
 */
import wysiwyg from './components/wysiwyg';

/**
 * @param {import('alpinejs').Alpine} Alpine
 */
export function registerWppWysiwyg(Alpine) {
    Alpine.data('wysiwyg', wysiwyg);
}

export { wysiwyg };
